import { useEffect, useState, useCallback, useRef } from "react";
import { getPaginatedSystems } from "../services/systemService";

const useFetchPaginatedSystems = ({
  setIsLoading,
  page,
  pSize,
  searchTerm,
  isActive = "true",
}: {
  setIsLoading: (loading: boolean) => void;
  page: number;
  pSize: number;
  searchTerm?: string;
  isActive?: string;
}) => {
  const [systemsData, setSystemsData] = useState<any>();
  const abortControllerRef = useRef<AbortController | null>(null);

  const fetchSystems = useCallback(
    async (searchQuery?: string) => {
      // Cancel previous request if it exists
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }

      // Create new abort controller for this request
      abortControllerRef.current = new AbortController();

      try {
        setIsLoading(true);
        const result = await getPaginatedSystems(
          page,
          pSize,
          searchQuery || searchTerm,
          abortControllerRef.current.signal,
          isActive
        );
        console.log("useFetchPaginatedSystems - API result:", result);
        setSystemsData(result);
      } catch (error: any) {
        console.error("Error fetching paginated systems:", error);
        // Don't update state if request was aborted
        if (error.name !== "AbortError") {
          setSystemsData(null);
        }
      } finally {
        setIsLoading(false);
      }
    },
    [setIsLoading, page, pSize, searchTerm, isActive]
  );

  useEffect(() => {
    fetchSystems();
  }, [fetchSystems]);

  // Cleanup function to abort any pending requests
  useEffect(() => {
    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, []);

  return [systemsData, fetchSystems];
};

export default useFetchPaginatedSystems;
